import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '@/store/auth';
import { LayoutDashboard, ListChecks, Users, LogOut, FileText, ShieldCheck, KeyRound, AlertTriangle, BarChart3, BookUser, Scale, Gavel, MapPin } from 'lucide-react';
import { CambiarPasswordModal } from './CambiarPasswordModal';

const NAV_STAFF = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/avance', label: 'Avance', icon: BarChart3 },
  { to: '/listas', label: 'Listas', icon: ListChecks },
  { to: '/candidatos', label: 'Candidatos', icon: Users },
  { to: '/padron', label: 'Padrón', icon: BookUser },
  { to: '/normativa', label: 'Normativa', icon: Scale },
  { to: '/validacion', label: 'Validación', icon: ShieldCheck },
  { to: '/expediente-jee', label: 'Expediente JEE', icon: Gavel },
];

// Entrada admin-only: solo ADM/PLT/PLA pueden gestionar Coordinadores
const NAV_ADMIN_EXTRA = [
  { to: '/coordinadores', label: 'Coordinadores', icon: MapPin },
];

// Rol CAR_DJHV solo carga DJHVs · acceso restringido al módulo DJHV
const NAV_CAR_DJHV = [
  { to: '/candidatos', label: 'Candidatos (DJHV)', icon: Users },
];

export function Layout() {
  const { nombre, rol, username, logout, passwordTemporal, candidatoId } = useAuth();
  const NAV_CANDIDATO = [
    { to: candidatoId ? `/candidatos/${candidatoId}` : '/portal', label: 'Mi expediente', icon: FileText },
  ];
  let NAV = NAV_STAFF;
  if (rol === 'CAN') NAV = NAV_CANDIDATO;
  else if (rol === 'CAR_DJHV') NAV = NAV_CAR_DJHV;
  else if (rol === 'ADM' || rol === 'PLT' || rol === 'PLA') NAV = [...NAV_STAFF, ...NAV_ADMIN_EXTRA];
  const nav = useNavigate();
  const [showPwdModal, setShowPwdModal] = useState(false);
  const onLogout = () => {
    logout();
    nav('/login');
  };
  return (
    <div className="min-h-screen flex bg-gray-50">
      {showPwdModal && <CambiarPasswordModal onClose={() => setShowPwdModal(false)} />}
      <aside className="w-64 bg-arpp-primary text-white flex flex-col">
        <div className="px-5 py-5 border-b border-white/10">
          <div className="text-lg font-bold leading-tight">ARPP-JEE</div>
          <div className="text-xs opacity-80">Control Inscripción ERM2026</div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded text-sm transition ${
                  isActive ? 'bg-white/15 font-medium' : 'hover:bg-white/10 opacity-90'
                }`
              }
            >
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 text-xs space-y-2">
          <div className="font-medium">{nombre || username}</div>
          <div className="opacity-70">{rol}</div>
          <button
            onClick={() => setShowPwdModal(true)}
            className="flex items-center gap-2 text-white/90 hover:text-white"
          >
            <KeyRound size={14} /> Cambiar contraseña
          </button>
          <button
            onClick={onLogout}
            className="flex items-center gap-2 text-white/90 hover:text-white"
          >
            <LogOut size={14} /> Cerrar sesión
          </button>
        </div>
        <div className="p-3 text-[10px] opacity-50 border-t border-white/10">
          <FileText size={11} className="inline mr-1" /> SPEC v2.0 · cierre 16-jun-2026
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        {passwordTemporal && (
          <div className="bg-amber-100 border-b border-amber-300 text-amber-900 px-6 py-2 text-sm flex items-center justify-between">
            <div className="flex items-center gap-2">
              <AlertTriangle size={16} />
              <span>Tu contraseña es <strong>temporal</strong>. Cambia tu contraseña ahora.</span>
            </div>
            <button
              onClick={() => setShowPwdModal(true)}
              className="bg-amber-600 hover:bg-amber-700 text-white px-3 py-1 rounded text-xs font-medium"
            >
              Cambiar ahora
            </button>
          </div>
        )}
        <Outlet />
      </main>
    </div>
  );
}
